import type { ActionItemChipStatus } from "@app/common/types";

export const AUTO_ACTION_ITEM_STATUSES = [
  "read_active",
  "read_inactive",
  "read_complete",
];

export const ACTION_ITEM_STATUS_CONFIG: {
  [key in ActionItemChipStatus]: {
    label: string;
    background: { main: string; hover: string };
  };
} = {
  read_active: {
    label: "Active",
    background: { main: "#3471CC", hover: "#1750A6" },
  },
  read_inactive: {
    label: "Inactive",
    background: { main: "#656565", hover: "#3D3D3D" },
  },
  read_complete: {
    label: "Complete",
    background: { main: "#2DB27B", hover: "#1D8D5E" },
  },
  user_active: {
    label: "Active",
    background: { main: "#3471CC", hover: "#1750A6" },
  },
  user_inactive: {
    label: "Inactive",
    background: { main: "#656565", hover: "#3D3D3D" },
  },
  user_complete: {
    label: "Complete",
    background: { main: "#2DB27B", hover: "#1D8D5E" },
  },
};
